import type { TimeseriesPoint } from "@busright/data-contract";

const SATURDAY = 6;
const SUNDAY = 0;

// The health trend is a weekday-only series (buses don't run weekends). Defensive filter in case a
// live payload ever includes weekend points; the snapshot already excludes them.
export const weekdaysOnly = (points: readonly TimeseriesPoint[]): TimeseriesPoint[] =>
  points.filter((p) => {
    const day = new Date(`${p.date}T00:00:00Z`).getUTCDay();
    return day !== SATURDAY && day !== SUNDAY;
  });

// First→last delta of a series, for a headline "trend over window" readout.
export const seriesDelta = (points: readonly TimeseriesPoint[]): number | null => {
  if (points.length < 2) {
    return null;
  }
  return points[points.length - 1].value - points[0].value;
};
